import { v4 as uuid } from 'uuid';
import { dispatch } from '../../store';
import { toastAction } from '../../store/slices/toast.slice';
import { diContainer } from '../../libs/container';

type ToastType = 'error' | 'success' | 'warn';
//investigate if we can mock actions in redux so we do not need this layer

export class ToastStateHandler {
    public push(type: ToastType, title: string, message?: string, id?: string) {
        if (id === undefined) {
            id = uuid();
        }
        dispatch(toastAction.push({ type, title, message, id }));
    }

    public pop(id: string) {
        dispatch(toastAction.pop({ id }));
    }
}

diContainer.bindAsConstant(ToastStateHandler, new ToastStateHandler());
